export enum PersistedKeys {
  ClinicName = 'clinicName',
  AppName = 'appName',
}
